/**
 * Vuex store for initialy loading analytics data
 */
// import { Cta } from "@authentic-labs/survey-builder"
import { getAnalyticsData, fetchProductLinkResults } from "@/services/AnalyticsService";
import { Commit } from "vuex";

interface AnalyticState {
    analyticsData: object;
}

const initialState = {
};

export default {
    state: initialState,

    getters: {
        analyticsData(state: AnalyticState) {
        return state.analyticsData;
        },
    },

    actions: {
        async getAnalyticsData({ commit }: { commit: Commit }, { companyId, dateRange, productId, productLinkId }: { companyId: number, dateRange: object, productId: number, productLinkId: number }) {
            const data = await getAnalyticsData(companyId, dateRange, productId);
            const productLinkResponse = await fetchProductLinkResults(companyId, dateRange, productLinkId);
            if (productLinkResponse && productLinkResponse.productLinkViewsDate) {
                commit("setAnalyticsData", Object.assign(data, { dateRange, productId, productLinkViewsDate: productLinkResponse.productLinkViewsDate, productLinkTopViews: productLinkResponse.productLinkTopViews, productLinkInfo: productLinkResponse.productLinkInfo }));
            } else {
                commit("setAnalyticsData", Object.assign(data, { dateRange, productId }));
            }
        }
    },

    mutations: {
        setAnalyticsData(state: AnalyticState, data: object) {
            state.analyticsData = data;
        },
        resetAnalyticsData(state: AnalyticState) {
            state.analyticsData = {};
        }
    },
}